import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiLinkedin, FiGlobe, FiMail, FiHeart } = FiIcons;

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-10 h-10 bg-gradient-to-r from-blue-600 to-indigo-600 rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-lg">JJ</span>
              </div>
              <div>
                <h3 className="text-xl font-bold">Jonas Jaani</h3>
                <p style={{
      color: 'rgb(156, 163, 175)'
    }} className="text-gray-400 text-sm">IT-konsult</p>
              </div>
            </div>
            <p className="text-gray-400 leading-relaxed">
              Hjälper dig att lyckas inom IT-branschen med praktiska råd 
              och expertkunskap från 20+ år som IT-konsult och teamchef.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
          >
            <h4 className="text-lg font-semibold mb-4">Snabblänkar</h4>
            <ul className="space-y-2">
              <li>
                <a style={{
      color: 'rgb(156, 163, 175)'
    }} href="#it-konsult" className="text-gray-400 hover:text-white transition-colors duration-200">IT-konsulttips</a>
              </li>
              <li>
                <a style={{
      color: 'rgb(156, 163, 175)'
    }} href="#skills" className="text-gray-400 hover:text-white transition-colors duration-200">Tekniska färdigheter</a>
              </li>
              <li>
                <a href="#webinar" className="text-gray-400 hover:text-white transition-colors duration-200">
                  Webinar
                </a>
              </li>
              <li>
                <a href="#resurser" className="text-gray-400 hover:text-white transition-colors duration-200">
                  Resurser
                </a>
              </li>
            </ul>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <h4 className="text-lg font-semibold mb-4">Kontakt & Följ</h4>
            <div className="space-y-4">
              <a
                href="https://www.linkedin.com/in/jonasjaani/"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center space-x-3 text-gray-400 hover:text-white transition-colors duration-200"
              >
                <SafeIcon icon={FiLinkedin} className="w-5 h-5" />
                <span>LinkedIn - Jonas Jaani</span>
              </a>
              <a
                href="https://www.jonasjaani.se"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center space-x-3 text-gray-400 hover:text-white transition-colors duration-200"
              >
                <SafeIcon icon={FiGlobe} className="w-5 h-5" />
                <span>jonasjaani.se</span>
              </a>
              <a
                href="mailto:jonas@jonasjaani.se"
                className="flex items-center space-x-3 text-gray-400 hover:text-white transition-colors duration-200"
              >
                <SafeIcon icon={FiMail} className="w-5 h-5" />
                <span>jonas@jonasjaani.se</span>
              </a>
            </div>
          </motion.div>
        </div>

        <motion.div
          className="border-t border-gray-800 pt-8 mt-8 text-center"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <p className="text-gray-400 flex items-center justify-center space-x-2">
            <span>© 2025 Jonas Jaani. Skapad med</span>
            <SafeIcon icon={FiHeart} className="w-4 h-4 text-red-500" />
            <span>för IT-karriärer</span>
          </p>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;